import { useState } from 'react';
import { Link } from '#components/atoms/link/Link.tsx';
import { CopyIDMenuItem } from '#components/patterns/menus/meatball-menu/CopyIDMenuItem.tsx';
import { MeatballMenu, MenuItem } from '#components/patterns/menus/meatball-menu/index.ts';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { DeleteRouteDialog } from '#screens/routes/delete/DeleteRouteDialog.tsx';

type Props = {
  id: `route-${string}`;
};

export function RoutesActionMenu({ id }: Props) {
  const [showDeletionModal, setShowDeletionModal] = useState<boolean>(false);
  const location = useAppLocation();

  return (
    <>
      <MeatballMenu>
        <CopyIDMenuItem id={id} />
        <MenuItem render={<Link to={id} state={{ from: location }} />}>Edit</MenuItem>
        <MenuItem onClick={() => setShowDeletionModal(true)}>Delete</MenuItem>
      </MeatballMenu>
      {showDeletionModal ?
        <DeleteRouteDialog
          routeId={id}
          onCancel={() => setShowDeletionModal(false)}
          onDelete={() => setShowDeletionModal(false)}
        />
      : null}
    </>
  );
}
